import { CommonJS } from '../functions/commonjs';

export module GraphOptions {

    export class LINE_COLORS {
        backgroundColor: string;
        borderColor: string;
        pointRadius: number;
        pointHitRadius: number;
        pointBackgroundColor: string;
        pointBorderColor: string;
        pointHoverBackgroundColor: string;
        pointHoverBorderColor: string;
        lineTension: number;
        borderDash: Array<number>;

        public static ROSSO: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#b73f24',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#b73f24',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#b73f24',
            lineTension: 0.3,
            borderDash: []
        };

        public static GIALLO: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#e8b622',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#e8b622',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#e8b622',
            lineTension: 0.3,
            borderDash: []
        };

        public static GRIGIO_AZZURRO: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#7899cc',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#7899cc',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#7899cc',
            lineTension: 0.3,
            borderDash: []
        };

        public static GRIGIO: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#7a7a7a',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#7a7a7a',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#7a7a7a',
            lineTension: 0.3,
            borderDash: []
        };

        public static GRIGIO_CHIARO: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#b2b2b2',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#b2b2b2',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#b2b2b2',
            lineTension: 0.3,
            borderDash: []
        };

        public static VERDE: LINE_COLORS = {
            backgroundColor: 'transparent',
            borderColor: '#18911c',
            pointRadius: 0,
            pointHitRadius: 10,
            pointBackgroundColor: '#18911c',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#18911c',
            lineTension: 0.3,
            borderDash: []
        };
    }

    export class BAR_COLORS {
        backgroundColor: string;
        borderColor: string;

        public static AZZURRO: BAR_COLORS = {
            backgroundColor: 'rgba(142, 204, 229, 1)',
            borderColor: 'rgba(142, 204, 229, 1)'
        };

        public static GRIGIO_AZZURRO: BAR_COLORS = {
            backgroundColor: 'rgba(120, 153, 204, 1)',
            borderColor: 'rgba(120, 153, 204, 1)'
        };

        public static GRIGIO_AZZURRO_CHIARO: BAR_COLORS = {
            backgroundColor: 'rgba(153, 171, 198, 1)',
            borderColor: 'rgba(153, 171, 198, 1)'
        };

        public static ROSSO: BAR_COLORS = {
            backgroundColor: 'rgba(183, 63, 36, 1)',
            borderColor: 'rgba(183, 63, 36, 1)'
        };

        public static ROSSO_CHIARO: BAR_COLORS = {
            backgroundColor: 'rgba(229, 150, 133, 1)',
            borderColor: 'rgba(229, 150, 133, 1)'
        };

        public static GIALLO: BAR_COLORS = {
            backgroundColor: 'rgba(232, 182, 34, 1)',
            borderColor: 'rgba(232, 182, 34, 1)'
        };

        public static GIALLO_CHIARO: BAR_COLORS = {
            backgroundColor: 'rgba(252, 227, 153, 1)',
            borderColor: 'rgba(252, 227, 153, 1)'
        };

        public static VERDE: BAR_COLORS = {
            backgroundColor: 'rgba(24, 145, 28, 1)',
            borderColor: 'rgba(24, 145, 28, 1)'
        };

        public static VERDE_CHIARO: BAR_COLORS = {
            backgroundColor: 'rgba(138, 204, 114, 1)',
            borderColor: 'rgba(138, 204, 114, 1)'
        };

        public static GRIGIO: BAR_COLORS = {
            backgroundColor: '#7a7a7a',
            borderColor: '#7a7a7a'
        };
    }
    export class PIE_COLORS {
        backgroundColor: string;
        borderColor: string;

        public static AZZURRO: PIE_COLORS = {
            backgroundColor: 'rgba(142, 204, 229, 1)',
            borderColor: 'rgba(142, 204, 229, 1)'
        };

        public static GRIGIO_AZZURRO: PIE_COLORS = {
            backgroundColor: 'rgba(120, 153, 204, 1)',
            borderColor: 'rgba(120, 153, 204, 1)'
        };

        public static GRIGIO_AZZURRO_CHIARO: PIE_COLORS = {
            backgroundColor: 'rgba(153, 171, 198, 1)',
            borderColor: 'rgba(153, 171, 198, 1)'
        };

        public static ROSSO: PIE_COLORS = {
            backgroundColor: 'rgba(183, 63, 36, 1)',
            borderColor: 'rgba(183, 63, 36, 1)'
        };

        public static ROSSO_CHIARO: PIE_COLORS = {
            backgroundColor: 'rgba(229, 150, 133, 1)',
            borderColor: 'rgba(229, 150, 133, 1)'
        };

        public static GIALLO: PIE_COLORS = {
            backgroundColor: 'rgba(232, 182, 34, 1)',
            borderColor: 'rgba(232, 182, 34, 1)'
        };

        public static GIALLO_CHIARO: PIE_COLORS = {
            backgroundColor: 'rgba(252, 227, 153, 1)',
            borderColor:'rgba(252, 227, 153, 1)'
        };

        public static VERDE: PIE_COLORS = {
            backgroundColor: 'rgba(24, 145, 28, 1)',
            borderColor: 'rgba(24, 145, 28, 1)'
        };

        public static VERDE_CHIARO: PIE_COLORS = {
            backgroundColor: 'rgba(138, 204, 114, 1)',
            borderColor : 'rgba(138, 204, 114, 1)'
        };

        public static GRIGIO: PIE_COLORS = {
            backgroundColor: '#7a7a7a',
            borderColor : '#7a7a7a'
        };
    }

    export class LineChartColors extends Array<LINE_COLORS>{
        constructor(colors: LINE_COLORS[]) {
            super();
            colors.forEach(c => this.push(CommonJS.clone(c)));
        }
        clone(): LineChartColors {
            return CommonJS.clone(this);
        }
    }

    export class BarChartColors extends Array<BAR_COLORS>{
        constructor(colors: BAR_COLORS[]) {
            super();
            colors.forEach(c => this.push(CommonJS.clone(c)));
        }
        clone(): BarChartColors {
            return CommonJS.clone(this);
        }
    }
    export class ChartOptions {
        animation: any;
        responsive: boolean;
        maintainAspectRatio: boolean;
        legend: {};
        scales: {
            xAxes: [{}],
            yAxes: [{}]
        };
        tooltips: {
            callbacks: { label: Function }
        };
        setHorizontalBarTooltip: boolean = false;

        public setTooltipLabel(callback: Function) {
            this.tooltips.callbacks.label = callback;
        }

        public static horizontalBarTooltip = (tooltipItem, data) => " " + data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.xLabel.toLocaleString('it-IT');

        public static Default(options: any = null): ChartOptions {
            let c = new ChartOptions();
            c.responsive = true;
            c.maintainAspectRatio = false;
            c.legend = { display: true };
            c.scales = {
                xAxes: [
                    {
                        ticks: {
                            min: 0,
                            callback: (value, index, values) => value.toLocaleString('it-IT')
                        }
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            min: 0,
                            callback: (value, index, values) => value.toLocaleString('it-IT')
                        }
                    }
                ]
            };
            c.tooltips = {
                callbacks: {
                    label: (tooltipItem, data) => " " + data.datasets[tooltipItem.datasetIndex].label + ": " + tooltipItem.yLabel.toLocaleString('it-IT')
                }
            }

            if (options) for (var p in options) { if (options.hasOwnProperty(p)) c[p] = options[p]; }
            if (c.setHorizontalBarTooltip) c.tooltips.callbacks.label = ChartOptions.horizontalBarTooltip;
            return c;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/models/graph-options.ts